export const languageFields = [
  { key: "pt", language: "portuguese" },
  { key: "en", language: "english" },
  { key: "es", language: "spanish" },
  { key: "fr", language: "french" },
  { key: "de", language: "german" },
  { key: "it", language: "italian" }
];
